<template src="./template/index.html"></template>
<script>
import Datepicker from "vuejs-datepicker";
import DibbleJS from "../../../dibble";
import DibbleAPI from "@/api";
import DibbleApi from "@/api";

export default {
    name: "AddCouponModal",
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        item: {
            type: Object,
            default: () => {
                return null
            }
        },
    },
    components: { Datepicker },
    data() {
        return {
            dibbleJs: DibbleJS,
            couponNumber: '',
            couponValue: '',
            notes: '',
            validThru: this.$moment().add(1, 'year').format('YYYY-MM-DD')
        }
    },
    computed: {
        isAddMode() {
            return this.item === null
        }
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
        submitCoupon () {
            const params = {
                request: this.isAddMode ? DibbleAPI.api.addCoupon : DibbleAPI.api.updateCoupon,
                value: this.couponValue,
                valid_thru_date: this._formatDatetimeOutputForApi(this.validThru),
                note: this.notes
            }

            if (!this.isAddMode) {
                params.coupon_number = this.couponNumber
            }

            DibbleJS.showLoader()
            DibbleJS.callApiRequest(params, response => {
                DibbleJS.hideLoader();
                if (DibbleApi.isResponseSuccess(response)) {
                    DibbleJS.toastSuccessMessage(response.message);
                    this.couponValue = '';
                    this.notes = '';
                    this.valid_thru = this.$moment().add(1, 'year').format('YYYY-MM-DD');
                    this.$emit("saved");
                } else {
                    DibbleJS.toastErrorMessage(response.message);
                }
            });
        },
        customFormatter(date) {
            return this.$moment(date).format("MM/DD/YYYY");
        },
        _formatDatetimeOutputForApi(m) {
            return this.$moment(m).format("YYYY-MM-DD");
        },
    },
    watch: {
        item(val) {
            this.couponNumber = val ? val.coupon_number : ''
            this.couponValue = val ? val.value : ''
            this.validThru = val ? val.valid_thru : '',
            this.notes = val ? val.note : ''
        }
    }
}
</script>

<style lang="scss">
.modal {
    background: transparent;
    transition: opacity 0.15s linear;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    .modal-form {
        display: flex;
        height: auto;
        align-items: center;
        .content {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 8px;
            width: 100%;
            .title {
                font-size: 14px;
                margin: 0;
                margin-right: 10px;
            }
        }
    }
    button {
        float: right;
    }
}
.modal-fade-enter,
.modal-fade-leave-active {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 0.5s ease;
}

.dollar-sign-prepend {
 color: #969fa2;
 position: absolute;
 bottom: 10px;
 left: 13px;
 font-size: 16px;
}
</style>
